import React from 'react'

function LinkImage() {
    return (
        <>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAASElEQVQYlWP8//8/Ay4wa4orXJIFmyADAwNDWs5uRmQ+48zJLv/RBbGZyoTTXlxW41IEsw2riejuxaoQ3SScVuPyGAsuq9ABALjiINuvH0khAAAAAElFTkSuQmCC" alt="Link" />
        </>
    )
}

export default LinkImage
